import { render, staticRenderFns } from "./ModalFirstLogin.vue?vue&type=template&id=4b76a066&scoped=true"
import script from "./ModalFirstLogin.vue?vue&type=script&lang=js"
export * from "./ModalFirstLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76a066",
  null
  
)

export default component.exports